import React, { useState } from "react";
import Badges from "./Badges";
import { useAuth } from "../context/auth-context";
import { useNavigate, Link } from "react-router-dom";
import { getTags, filterTags, filterFlyers } from "../util/filterTags";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function FlyerTable({ flyers }) {
  const { currentUser } = useAuth();
  const history = useNavigate();

  const currentDate = new Date().toISOString();

  let filteredFlyers = flyers;

  const [search, setSearch] = useState("");
  const [flyersSortedByTags, setFlyersSortedByTags] = useState([]);

  const [sortOption, setSortOption] = useState("");

  let flyersSorted = flyers.sort((a, b) => a.name.localeCompare(b.name));

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(8);
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;

  const sortedFlyers = flyersSorted.slice(indexOfFirstPost, indexOfLastPost);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const nextPage = () => {
    if (currentPage < Math.ceil(flyers.length / postsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const firstPage = () => {
    setCurrentPage(1);
  };
  const lastPage = () => {
    setCurrentPage(Math.ceil(flyers.length / postsPerPage));
  };

  const selectFlyer = (flyer) => {
    currentUser.flyerChoice = flyer;
    return history("/flyer-options");
  };

  //search through flyers and return filtered list
  const searchFlyers = (search) => {
    let filteredFlyers = flyers.filter((flyer) => {
      return flyer.name.toLowerCase().includes(search.toLowerCase());
    });
    // console.log(filteredFlyers);
    return filteredFlyers;
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    searchFlyers(e.target.value);
    firstPage();
    setFlyersSortedByTags([]);
    // set the value of the select input to Filter by Intended Audience or the first option
    document.getElementById("filter").selectedIndex = 0;
  };
  filteredFlyers = searchFlyers(search);

  const paginatedSoretedFlyers = filteredFlyers.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  const filteredSortedFlyers1 = filteredFlyers.sort((a, b) =>
    a.name.localeCompare(b.name)
  );
  const filteredIndexOfLastPost = currentPage * postsPerPage;
  const filteredIndexOfFirstPost = filteredIndexOfLastPost - postsPerPage;
  const filteredSortedFlyers = filteredSortedFlyers1.slice(
    filteredIndexOfFirstPost,
    filteredIndexOfLastPost
  );
  let allTags = getTags(flyers);
  let uniqueTags = filterTags(allTags);

  const filterFlyers = (tags) => {
    if (tags.length === 0) {
      return flyers;
    }

    const filteredFlyers = flyers.filter((flyer) => {
      return flyer.intendedAudience.some((tag) => tags.includes(tag));
    });
    // console.log(filteredFlyers);
    setFlyersSortedByTags(filteredFlyers);

    if (tags === "All") {
      setFlyersSortedByTags([]);
    }
  };

  // paginate flyersSortedByTags

  const flyersByTagsPaginated = flyersSortedByTags.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  // console.log(paginatedSoretedFlyers);

  const sortFlyers = (e) => {
    const option = e.target.value;
    setSortOption(option);

    let sortedFlyers = [];

    if (option === "A-Z") {
      sortedFlyers = filteredFlyers.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    } else if (option === "Z-A") {
      sortedFlyers = filteredFlyers.sort((a, b) =>
        b.name.localeCompare(a.name)
      );
    } else if (option === "Newest") {
      sortedFlyers = filteredFlyers.sort((a, b) => {
        if (a.created_date && b.created_date) {
          return new Date(b.created_date) - new Date(a.created_date);
        } else if (a.created_date) {
          return -1;
        } else if (b.created_date) {
          return 1;
        } else {
          return 0;
        }
      });
    } else if (option === "Oldest") {
      sortedFlyers = filteredFlyers.sort((a, b) => {
        if (a.created_date && b.created_date) {
          return new Date(a.created_date) - new Date(b.created_date);
        } else if (a.created_date) {
          return 1;
        } else if (b.created_date) {
          return -1;
        } else {
          return 0;
        }
      });
    } else {
      sortedFlyers = filteredFlyers;
    }

    setFlyersSortedByTags(sortedFlyers);
    console.log(sortedFlyers);
    setCurrentPage(1);
  };

  const handlePreview = (filepath) => {
    // window.open(filepath); ina  new tab
    window.open(filepath, "_blank"); // in the same tab
  };

  return (
    <div className="w-3/5 mx-auto pb-24">
      <div className="flex justify-end items-center -mb-6">
        <div className="mr-4">
          <select
            onChange={sortFlyers}
            id="filter"
            name="filter"
            className="block w-full pl-3 text-gray-500 pr-24 py-2 mt-1 text-base border-gray-300 focus:outline-none focus:ring-blue-primary focus:border-blue-primary sm:text-sm rounded-md"
            value={sortOption}
          >
            <option value="" disabled>
              Sort by
            </option>
            <option value="A-Z">A-Z</option>
            <option value="Z-A">Z-A</option>
            <option value="Newest">Newest</option>
            <option value="Oldest">Oldest</option>
          </select>
        </div>
        <div className="mr-4">
          <select
            onChange={(e) => {
              setCurrentPage(1);
              filterFlyers(e.target.value);
            }}
            id="filter"
            name="filter"
            className="block w-full pl-3 text-gray-500 pr-24 py-2 mt-1 text-base border-gray-300 focus:outline-none focus:ring-blue-primary focus:border-blue-primary sm:text-sm rounded-md"
          >
            <option
              value="All"
              defaultValue={""}
              label
              className="bg-gray-200 "
            >
              Filter by Intended Audience
            </option>
            <option value="All">All</option>
            {uniqueTags.map((tag) => (
              <option key={tag}>{tag}</option>
            ))}
          </select>
        </div>
        <div className="relative mt-1 flex items-center">
          <input
            placeholder="Search by Title"
            onChange={handleSearch}
            type="text"
            name="search"
            id="search"
            className="block w-full rounded-md border-gray-300 pr-12 shadow-sm focus:border-blue-primary focus:ring-blue-primary sm:text-sm w-80"
          />
          <div className="absolute inset-y-0 right-2 flex py-2 pr-1.5 rounded-full">
            <svg
              className="w-5 h-5 ml-2 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>
      </div>

      <div className="-mx-4 mt-10 ring-1 ring-gray-300 sm:-mx-6 md:mx-0 rounded-md bg-gray-50">
        {filteredFlyers.length > 0 ? (
          <table className="min-w-full divide-y divide-gray-300">
            <thead>
              <tr>
                <th
                  scope="col"
                  className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-gray-900 sm:pl-6"
                >
                  Flyer Name
                </th>
                <th
                  scope="col"
                  className="hidden px-3 py-3.5 text-left text-sm font-bold text-gray-900 lg:table-cell"
                >
                  Intended Audience
                </th>
                {/* <th
                scope="col"
                className="px-3 py-3.5 text-left text-sm font-bold text-gray-900"
              >
                Price
              </th> */}
              </tr>
            </thead>
            <tbody>
              {flyersSortedByTags.length > 0
                ? flyersByTagsPaginated.map((flyer, flyeridx) => (
                    <tr
                      key={flyer.id}
                      className={classNames(
                        flyeridx % 2 === 1 ? "bg-gray-100/50" : ""
                      )}
                    >
                      <td
                        width={"500px"}
                        className={classNames(
                          flyeridx === 0 ? "" : "border-t border-transparent",
                          "relative py-4 pl-4 sm:pl-6 pr-3 text-sm"
                        )}
                      >
                        <div className="font-medium text-gray-900 text-left text-[15px]">
                          {flyer.name}
                          {flyer.created_date &&
                          new Date(currentDate) -
                            new Date(flyer.created_date) <=
                            30 * 24 * 60 * 60 * 1000 ? (
                            <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-full opacity-50 bg-blue-primary text-white text-xs font-semibold uppercase tracking-wide border-2">
                              New
                            </span>
                          ) : null}
                        </div>

                        {flyeridx !== 0 ? (
                          <div className="absolute right-0 left-6 -top-px h-px bg-gray-200" />
                        ) : null}
                      </td>
                      <td
                        className={classNames(
                          flyeridx === 60
                            ? ""
                            : "border-t border-gray-200 text-left",
                          "hidden px-3 py-3.5 text-sm text-gray-500 lg:table-cell"
                        )}
                      >
                        {flyer.intendedAudience.map((audience) => (
                          <Badges key={audience} content={audience} />
                        ))}
                      </td>
                      <td
                        className={classNames(
                          flyeridx === 0 ? "" : "border-t border-gray-200",
                          "hidden px-3 py-3.5 text-sm text-gray-500 lg:table-cell"
                        )}
                      >
                        {flyer.storage}
                      </td>
                      <td
                        className={classNames(
                          flyeridx === 0 ? "" : "border-t border-transparent",
                          "relative py-3.5 pl-3 pr-4 sm:pr-6 text-right text-sm font-medium"
                        )}
                      >
                        <button
                          onClick={() => handlePreview(flyer.filePath)}
                          type="button"
                          className="mr-4 inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium leading-4 text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-primary focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-30"
                        >
                          Preview Flyer
                          <span className="sr-only">, {flyer.name}</span>
                        </button>
                        <button
                          onClick={() => selectFlyer(flyer)}
                          type="button"
                          className="inline-flex items-center rounded-md  bg-blue-primary px-3 py-2 text-sm font-medium leading-4 text-gray-200 shadow-sm hover:bg-blue-dark focus:outline-none focus:ring-2 focus:ring-blue-primary focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-30"
                          disabled={flyer.isCurrent}
                        >
                          Generate Flyer
                          <span className="sr-only">, {flyer.name}</span>
                        </button>
                        {flyeridx !== 0 ? (
                          <div className="absolute right-6 left-0 -top-px h-px bg-gray-200" />
                        ) : null}
                      </td>
                    </tr>
                  ))
                : paginatedSoretedFlyers.map((flyer, flyeridx) => (
                    <tr
                      key={flyer.id}
                      className={classNames(
                        flyeridx % 2 === 1 ? "bg-gray-100/50" : ""
                      )}
                    >
                      <td
                        width={"500px"}
                        className={classNames(
                          flyeridx === 0 ? "" : "border-t border-transparent",
                          "relative py-4 pl-4 sm:pl-6 pr-3 text-sm"
                        )}
                      >
                        <div className="font-medium text-gray-900 text-left text-[15px]">
                          {flyer.name}
                        </div>

                        {flyeridx !== 0 ? (
                          <div className="absolute right-0 left-6 -top-px h-px bg-gray-200" />
                        ) : null}
                      </td>
                      <td
                        className={classNames(
                          flyeridx === 60
                            ? ""
                            : "border-t border-gray-200 text-left",
                          "hidden px-3 py-3.5 text-sm text-gray-500 lg:table-cell"
                        )}
                      >
                        {flyer.intendedAudience.map((audience) => (
                          <Badges key={audience} content={audience} />
                        ))}
                      </td>
                      <td
                        className={classNames(
                          flyeridx === 0 ? "" : "border-t border-gray-200",
                          "hidden px-3 py-3.5 text-sm text-gray-500 lg:table-cell"
                        )}
                      >
                        {flyer.storage}
                      </td>
                      <td
                        className={classNames(
                          flyeridx === 0 ? "" : "border-t border-transparent",
                          "relative py-3.5 pl-3 pr-4 sm:pr-6 text-right text-sm font-medium flex justify-end"
                        )}
                      >
                        <button
                          onClick={() => handlePreview(flyer.filePath)}
                          type="button"
                          className="mr-4 inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium leading-4 text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-primary focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-30"
                        >
                          Preview
                          <span className="sr-only">, {flyer.name}</span>
                        </button>
                        <button
                          onClick={() => selectFlyer(flyer)}
                          type="button"
                          className="inline-flex items-center rounded-md  bg-blue-primary px-3 py-2 text-sm font-medium leading-4 text-gray-200 shadow-sm hover:bg-blue-dark focus:outline-none focus:ring-2 focus:ring-blue-primary focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-30"
                          disabled={flyer.isCurrent}
                        >
                          Generate Flyer
                          <span className="sr-only">, {flyer.name}</span>
                        </button>
                        {flyeridx !== 0 ? (
                          <div className="absolute right-6 left-0 -top-px h-px bg-gray-200" />
                        ) : null}
                      </td>
                    </tr>
                  ))}
            </tbody>
          </table>
        ) : (
          <div className="text-xl flex justify-center py-4 text-blue-primary font-bold">
            <h1>No Flyers Matching your Search Results</h1>
          </div>
        )}
      </div>

      {flyersSortedByTags.length < 1 || flyersSortedByTags.length > 8 ? (
        <div className="w-100 flex flex-row w-full justify-center space-x-4 p-6">
          <button
            onClick={firstPage}
            type="button"
            className="inline-flex items-center justify-center px-3 py-2 border border-gray-300 rounded-md text-sm font-medium leading-4 text-gray-700 bg-white shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-primary focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-30"
            disabled={currentPage === 1}
          >
            First Page
          </button>
          <button
            onClick={prevPage}
            type="button"
            className="inline-flex items-center justify-center px-3 py-2 border border-gray-300 rounded-md text-sm font-medium leading-4 text-gray-700 bg-white shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-primary focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-30"
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <div className="flex items-center justify-center text-gray-400/75 font-normal">
            {filteredFlyers.length > 0 ? (
              <h4>
                {currentPage} of{" "}
                {Math.ceil(filteredFlyers.length / postsPerPage)}
              </h4>
            ) : (
              <h4>0 of {Math.ceil(filteredFlyers.length / postsPerPage)}</h4>
            )}
          </div>
          <button
            onClick={nextPage}
            type="button"
            className="inline-flex items-center justify-center px-3 py-2 border border-gray-300 rounded-md text-sm font-medium leading-4 text-gray-700 bg-white shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-primary focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-30"
            disabled={
              currentPage === Math.ceil(filteredFlyers.length / postsPerPage) ||
              filteredFlyers.length === 0
            }
          >
            Next
          </button>
          <button
            onClick={lastPage}
            type="button"
            className="inline-flex items-center justify-center px-3 py-2 border border-gray-300 rounded-md text-sm font-medium leading-4 text-gray-700 bg-white shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-primary focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-30"
            disabled={
              currentPage === Math.ceil(filteredFlyers.length / postsPerPage) ||
              filteredFlyers.length === 0
            }
          >
            Last Page
          </button>
        </div>
      ) : null}
    </div>
  );
}
